module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAIAAAAmzuBxAAAApUlEQVR4nH2Pyw2CUBBFD/ASiCa6sSobsQVdEVa2oA3YgVZhBS5N1AUJBIOo74cLX4SgeJdzT87MePPVlr8RwHI27asX650AjNGeB+D74tMZo5R8OodSEoA6ihriVhZlkTsiigbf/tF4kqUXR7yTJEmbiOO4ubQz6sTv+wLQSjrH6Xh43CutpLWmXRutHJGl5/KaayltbduOIBAwFMBmX0EI4c9dL4aVQVntwfv4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon_collapse.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon_collapse.png
// module chunks = styles